<template>
  <div class="vip-center-entrance-component"
       @click="handleClick"
  >
    <ym-img class="icon-vip"
            :src="require('@/assets/img/vip/vip_round_icon.png')"
            alt="会员中心"
    />
    会员中心
  </div>
</template>

<script>
  export default {
    name: 'VipCenterEntrance',
    methods: {
      handleClick() {
        const route = { name: 'MyVipCenter' };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @vip-left-right-padding: @size-extra-small + @size-extra-small /2;
  .vip-center-entrance-component {
    height: @size-large;
    padding: 0 @vip-left-right-padding 0 @vip-left-right-padding;
    border-radius: @size-base;
    display: flex;
    align-items: center;
    border: @border-width-base @border-style-base @vip-primary-color;
    font-size: @font-size-base;
    font-weight: @font-weight-primary;
    color: @vip-primary-color;
    line-height: 1;
  }

  .icon-vip {
    display: block;
    margin-right: @size-extra-small;
    width: @size-medium;
    height: @size-medium;
  }
</style>
